import React from "react"
import DivContentLoader from "../../Component/DivContentLoader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faImages, faStar } from "@fortawesome/free-solid-svg-icons"
import { Trans } from "react-i18next"
import classNames from "classnames"
import ProfileLinksShareBox from "../../Component/ProfileLinksShareBox"
import { faAddressCard, faMap } from "@fortawesome/free-regular-svg-icons"

const AboutKOLLoading = () => {
  return (
    <div className="w-full pt-6 lg:p-4 p-2">
      {/* KOL Information*/}
      <section className="relative w-full mt-14 mb-4 bg-white shadow-md border border-gray-100 rounded-xl pt-20 pb-4 px-4 ">
        <div className="absolute -top-14 right-0.5 mx-auto inline-block w-full ">
          <div className="w-24 h-24 xl:w-32 xl:h-32 rounded-full mx-auto text-center">
            <DivContentLoader h={90} w={90} r={100} />
          </div>
        </div>

        <div className="text-center mx-auto">
          <h1 className="font-semibold text-lg lg:text-2xl p-0 m-0">
            <DivContentLoader w={90} h={15} r={10} />
            <span>
              <svg
                className="svg-inline--fa fa-instagram  w-5 h-5 ml-1"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="instagram"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-fa-i2svg="">
                <path
                  fill="currentColor"
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </span>
          </h1>

          <div className="text-xs font-light align-center mt-1 ml-auto block">
            <FontAwesomeIcon icon={faStar} className="mr-1 text-red-default" />
            <DivContentLoader w={20} h={10} r={10} /> / 5
          </div>
        </div>

        <div className="grid grid-cols-3 col-span-3 my-4">
          <div className={"text-center my-auto"}>
            <p className={"text-lg font-semibold"}>
              <DivContentLoader w={20} h={25} r={8} />
            </p>
            <h3 className="text-md text-gray-500 font-normal">
              <Trans>SignUp.posts</Trans>
            </h3>
          </div>
          <div className={"text-center  my-auto"}>
            <p className={"text-lg font-semibold"}>
              <DivContentLoader w={20} h={25} r={8} />
            </p>
            <h3 className="text-md text-gray-500 font-normal">
              <Trans>SignUp.followers</Trans>
            </h3>
          </div>
          <div className={"text-center  my-auto"}>
            <p className={"text-lg font-semibold"}>
              <DivContentLoader w={20} h={25} r={8} />
            </p>
            <h3 className="text-md text-gray-500 font-normal">
              <Trans>SignUp.following</Trans>
            </h3>
          </div>
        </div>

        <div className="overflow-y-hidden mt-8 mb-4 py-2 w-full whitespace-nowrap noScrollBar relative" />

        <div className="w-full">
          <button
            className={classNames(
              "btn btn-disabled w-full mt-2 h-12 rounded-xl normal-case "
            )}>
            <Trans>KOLProfile.contact-kol</Trans>
          </button>
        </div>
      </section>

      <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
        <ProfileLinksShareBox userName={""} disabled={true} />
      </section>

      <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
        <div>
          <FontAwesomeIcon
            className="text-md mr-2 text-gray-500"
            icon={faAddressCard}
          />
          <h2 className="inline-block text-md text-gray-800 ">
            <Trans>KOLProfile.kol-description</Trans>
          </h2>
        </div>
        <p className="mt-4 text-sm text-gray-500 max-h-40 h-auto overflow-x-hidden overflow-y-auto">
          <DivContentLoader w={320} h={90} r={15} />
        </p>
      </section>

      <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
        <div>
          <FontAwesomeIcon
            className="text-md mr-2 text-gray-500"
            icon={faImages}
          />
          <h2 className="inline-block text-md text-gray-800 ">
            <Trans>KOLProfile.kol-cover-image</Trans>
          </h2>
        </div>
        <div className="mt-4 mb-4 w-full ml-4">
          <DivContentLoader w={280} h={200} r={30} />
        </div>
      </section>

      <section
        className={"w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto"}>
        <div>
          <FontAwesomeIcon
            className="text-md mr-2 text-gray-500"
            icon={faMap}
          />
          <h2 className="inline-block text-md text-gray-800 ">
            <Trans>KOLProfile.location</Trans>
          </h2>
          <p className="text-xs text-gray-400 my-2">
            <Trans>KOLProfile.kol-location</Trans>
            <span className="text-primary">
              <DivContentLoader w={30} h={8} r={8} />
            </span>
          </p>

          <div>
            <DivContentLoader w={300} h={100} r={20} />
          </div>
        </div>
      </section>
    </div>
  )
}

export default AboutKOLLoading
